import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import BrandLogo from '../components/BrandLogo';

const CHARCOAL = '#1F2937';
const ORANGE = '#EF6622';

export default function Login() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [website, setWebsite] = useState('');

  if (user) { nav('/'); return null; }

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setBusy(true);
    try {
      await login(username, password, website);
      nav('/');
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  };

  const inputStyle = {
    width: '100%', padding: '12px', border: '1px solid #d1d5db',
    borderRadius: '8px', fontSize: '16px', background: '#fff',
  };
  const labelStyle = {
    display: 'block', fontSize: '13px', fontWeight: 600,
    color: '#9ca3af', marginBottom: '4px',
  };

  return (
    <div style={{
      minHeight: '100vh', background: CHARCOAL, display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', padding: '24px',
    }}>
      <div style={{ marginBottom: '32px' }}>
        <BrandLogo word="CRM" variant="stacked" size={76} wordSize={60} reverse />
      </div>

      <form onSubmit={submit} style={{ width: '100%', maxWidth: '360px' }}>
        {error && (
          <div style={{
            background: '#fee2e2', border: '1px solid #fca5a5', borderRadius: '8px',
            padding: '12px', marginBottom: '16px', color: '#991b1b', fontSize: '14px',
          }}>
            {error}
          </div>
        )}

        {/* Honeypot (server/utils/loginGuard.js): invisible to people, filled by bots. */}
        <input type="text" name="website" value={website} onChange={e => setWebsite(e.target.value)}
          tabIndex={-1} autoComplete="off" aria-hidden="true"
          style={{ position: 'absolute', left: '-9999px', width: 1, height: 1, opacity: 0 }} />
        <div style={{ marginBottom: '12px' }}>
          <label style={labelStyle}>Username</label>
          <input
            value={username}
            onChange={e => setUsername(e.target.value)}
            style={inputStyle}
            autoCapitalize="off"
            autoCorrect="off"
            autoFocus
            required
          />
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={labelStyle}>Password</label>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={inputStyle}
            required
          />
        </div>

        <button
          type="submit"
          disabled={busy}
          style={{
            background: ORANGE, color: '#fff', border: 'none', borderRadius: '8px',
            padding: '16px', fontSize: '18px', fontWeight: 600, width: '100%',
            cursor: 'pointer', opacity: busy ? 0.7 : 1,
          }}
        >
          {busy ? 'Signing in...' : 'Sign In'}
        </button>
      </form>

      <div style={{ marginTop: '20px', textAlign: 'center' }}>
        <Link to="/forgot" style={{ color: 'rgba(255,255,255,0.35)', fontSize: '13px', textDecoration: 'none' }}>
          Forgot password?
        </Link>
      </div>
    </div>
  );
}
